import { defineMessages } from 'react-intl';

const messages = defineMessages({
  searchInputPlaceholder: {
    id: 'collegeevents.locations.placeholder',
    defaultMessage: 'Select a location',
  },
  newLocation: {
    id: 'collegeevents.location.new',
    defaultMessage: '+ New Location',
  },
  editLocation: {
    id: 'collegeevents.location.edit',
    defaultMessage: 'Edit',
  },
  name: {
    id: 'collegeevents.location.name',
    defaultMessage: 'Name',
  },
  name_placeholder: {
    id: 'collegeevents.location.name_placeholder',
    defaultMessage: 'Location name',
  },
  address: {
    id: 'collegeevents.location.address',
    defaultMessage: 'Address',
  },
  address_placeholder: {
    id: 'collegeevents.location.address_placeholder',
    defaultMessage: 'Find an address',
  },
  save_location: {
    id: 'collegeevents.location.save_location',
    defaultMessage: 'Save location',
  },
  save: {
    id: 'collegeevents.location.save',
    defaultMessage: 'Done',
  },
  update: {
    id: 'collegeevents.location.update',
    defaultMessage: 'Update',
  },
  error: {
    id: 'collegeevents.location.error',
    defaultMessage: 'Cannot save location',
  },
  errorUniqueName: {
    id: 'collegeevents.location.error.uniqueName',
    defaultMessage: 'Location name should be unique.',
  },
  missingName: {
    id: 'collegeevents.location.missingName',
    defaultMessage: 'Please enter location name',
  },
  badAddress: {
    id: 'collegeevents.location.badAddress',
    defaultMessage: 'Please enter a valid US or Canadian address',
  },
  locationVirtualEventCheck: {
    id: 'collegeevents.location.virtualEventCheck',
    defaultMessage: 'This is a virtual event',
  },
  saveLocation: {
    id: 'collegeevents.location.savelocation',
    defaultMessage: 'Save location',
  },
  return: {
    id: 'collegeevents.location.return',
    defaultMessage: 'Return to list',
  },
  delete: {
    id: 'collegeevents.location.delete',
    defaultMessage: 'Delete this location',
  },
  no: {
    id: 'collegeevents.location.delete.confirmNo',
    defaultMessage: 'No',
  },
  yes: {
    id: 'collegeevents.location.delete.confirmYes',
    defaultMessage: 'Yes',
  },
  ok: {
    id: 'collegeevents.location.delete.messageOk',
    defaultMessage: 'Ok',
  },
  deleteWithPublishedEvent: {
    id: 'collegeevents.location.deleteWithPublishedEvent',
    defaultMessage: 'This location can not be deleted since it is associated with a published event',
  },
  deleteWithExpiredEvent: {
    id: 'collegeevents.location.deleteWithExpiredEvent',
    defaultMessage: 'This location is associated with a past published event. ',
  },
  deleteWithUnpublishedEvent: {
    id: 'collegeevents.location.deleteWithUnpublishedEvent',
    defaultMessage: 'This location is associated with an existing unpublished event. ',
  },
  deleteConfirmMessage: {
    id: 'collegeevents.location.delete.confirmMessage',
    defaultMessage: 'Are you sure you want to delete?',
  },
  deleteError: {
    id: 'collegeevents.location.deleteError',
    defaultMessage: 'Cannot delete location',
  },
});

export default messages;
